<template>
  <header class="head">
    <img @click="menuClick" :class="{'nav-active': navActive}" id="menu"   src="/static/images/more-routes.png">
    <h3 @click="toHome">UGIRL</h3>
    <!-- <button @click="downClick">下载App</button> -->
    <transition-group name="nav-list" tag="nav" class="nav-ul">
      <a class="nav-li"
         v-for="nav in menuNav"
         :style="{backgroundColor: nav.color}"
         :href="nav.path"
         :key="nav.id"
         v-show="navActive">{{ nav.name }}</a>
    </transition-group>
    <div class="head-down-spread" v-show="downUnfold">
      <!-- <a :href="OLD_UGIRL_URL" target="_blank">
        <img  src="/static/images/uguoquan.png"  width="50"/>
        <h5>尤果</h5>
        <p>原创美女写真套图</p>
      </a> -->
      <!-- <hr />
      <a :href="NEW_UGIRL_URL" target="_blank">
        <img :src="IMG_URL + 'wap/uguoquan.png'" width="50" />
        <h5>新尤果</h5>
        <p>会员专享视频私密社交</p>
      </a> -->
    </div>
  </header>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    data () {
      return {
        navActive: false,
        downUnfold: false
      }
    },
    methods: {
      menuClick () {
        this.navActive = !this.navActive
      },
      downClick () {
        this.downUnfold = !this.downUnfold
      },
      toHome () {
        window.location.href = '/'
      }
    },
    computed: {
      ...mapGetters({
        menuNav: 'menuNav'
      }),
    }

  }
</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";
  .head {
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    padding: px2rem(10px);
    background: #FFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    #menu {
      width: px2rem(20px);
      height: px2rem(16px);
    }
    h3 {
      position: relative;
      left: px2rem(20px);
      font-size: px2rem(24px);
      color: #ff5196;
      font-family: "didot";
    }
    button {
      width: px2rem(68px);
      height: px2rem(26px);
      border-radius: px2rem(15px);
      line-height: px2rem(26px);
      font-size: px2rem(12px);
      background-color: #FF5196;
      color: #FFF;
    }
    .nav-ul {
      display: flex;
      flex-direction: column;
      position: fixed;
      top: px2rem(45px);
      left: 0;
      right: 0;
      width: 100%;
      font-size: px2rem(16px);
      font-weight: 600;
      line-height: px2rem(24px);
      text-align: center;
      .nav-li {
        display: inline-block;
        padding: px2rem(10px);
        color: #fff;
      }
    }
    .nav-list-enter-active, .nav-list-leave-active {
      transition: all 300ms ease-in-out;
    }
    .nav-list-enter, .nav-list-leave-to {
      transform: translateY(30px);
      opacity: 0;
    }
    .nav-list-enter-active:nth-child(1n + 2) {
      transition-delay: 100ms;
    }
    .nav-list-enter-active:nth-child(1n + 3) {
      transition-delay: 200ms;
    }
    .nav-list-enter-active:nth-child(1n + 4) {
      transition-delay: 300ms;
    }
    .nav-list-enter-active:nth-child(1n + 5) {
      transition-delay: 400ms;
    }
    .nav-list-enter-active:nth-child(1n + 6) {
      transition-delay: 500ms;
    }
    .nav-active {
      transition: transfrom 5s ease-in;
      transform: rotate(90deg);
    }
  }
  .head-down-spread {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    transform: translateY(1rem);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: .4rem .2rem;
    text-align: center;
    background-color: #fff;
    hr {
      width: 2px;
      height: 1.2rem;
      margin: 0 .6rem;
      background-color: #ccc;
      border: none;
    }
    h5 {
      padding: .2rem 0 .1rem;
      color: #444;
    }
    p {
      font-size: .24rem;
      color: #777;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Nav.vue